import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useSeoContext } from '@sorare/core/src/contexts/seo';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { CreatorProgram as CreatorsProgramContent } from 'CreatorsProgram';

const messages = defineMessages({
  title: {
    id: 'creator-program.meta.title',
    defaultMessage: 'Become a Creator on Sorare',
  },
  description: {
    id: 'creator-program.meta.description',
    defaultMessage:
      'Join the Creator Program and earn rewards for your content.',
  },
});

const AffiliateProgram = () => {
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  useEffect(
    () =>
      setPageMetadata(formatMessage(messages.title), {
        description: formatMessage(messages.description),
      }),
    [setPageMetadata, formatMessage]
  );

  return (
    <AppLayout>
      <CreatorsProgramContent />
    </AppLayout>
  );
};

export default AffiliateProgram;
